// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PrivateEmbedSettings = (props: any) => {
  return null;
};
